// react
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

// api
import { useGetSystemStatusQuery } from '@/api/system-status/systemStatusApiSlice';

// components
import { setBannerStatus } from '@/redux/systemBannerSlice';

// relative
import UpdateBanner from './UpdateBanner';

/**
 * AppBarBanner - A persistent global banner that displays system status
 * Only shows the update banner (news is now handled by ReleaseNotesButton in AppBar)
 * Shows:
 * - An "Update in progress" banner when system is updating
 * - Nothing when status is normal or news
 */
const AppBarBanner = () => {
  const dispatch = useDispatch();

  // Fetch system status with automatic polling
  const { data: statusData, isLoading, error } = useGetSystemStatusQuery();

  // Update Redux store when status changes
  useEffect(() => {
    if (statusData) {
      dispatch(
        setBannerStatus({
          status: statusData.status || 'normal',
          message: statusData.message || '',
          releaseNotes: statusData.releaseNotes || '',
          version: statusData.version || '',
        }),
      );
    }
  }, [statusData, dispatch]);

  // Show loading indicator on first load
  if (isLoading && !statusData) {
    return null;
  }

  if (error) {
    return null;
  }

  const status = statusData?.status || 'normal';

  // Only render update banner - news is handled in AppBar
  if (status === 'updating') {
    return <UpdateBanner message={statusData?.message} />;
  }

  return null;
};

export default AppBarBanner;
